export default "__VITE_ASSET__CowMxvOe__"